import React from 'react'
import {WrapperCenter, Message} from '../../styleComponents/index.js'

export const NotFoundPage = () => (
    <WrapperCenter>
        <Message>404 - Page not found</Message>
    </WrapperCenter>
);